/**
 * 区分 metricType（goals.metric_type）
 * 出典：仕様書 7 章
 */
export const METRIC_TYPE_VALUES = ['amount', 'count', 'percentage', 'currency'] as const;

export type MetricType = (typeof METRIC_TYPE_VALUES)[number];

export const METRIC_TYPE_LABELS: Readonly<Record<MetricType, string>> = {
  amount: '金額',
  count: '件数',
  percentage: 'パーセント', // 274：旧PCRM の表示名（値は変えない）
  currency: '通貨',
};
